import { useState, useEffect, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import { getAllGroups } from 'store/entities/groups/action';
import Filter from "components/__new/common/Filter";
// import Print from 'components/__new/common/Print';
import Table from 'components/__new/common/Table';
import DateFormat from 'utils/dateFormat';
// import Print from 'components/__new/common/Print';
import DownloadAsCSV from "components/__new/common/DownloadAsCSV";
import { useLocation, useHistory, useParams } from 'react-router-dom';
import * as employeesAction from "store/entities/employees/action";
import * as groupActions from "store/entities/groups/action";
import SearchBox from 'components/__new/common/SearchBox';
import useUrlQueryParams from 'hooks/useUrlQueryParams';
import processParams from 'utils/processParams';
import DynamicHeadTag from 'components/__new/common/DynamicHeadTag';
import { TableContent } from 'components/__new/common/TableContent';
import DialogBox from 'utils/dialogBox';
import Maybe from "components/__new/common/Maybe";
import { ReactComponent as ArrowBack } from "assets/images/icons/arrow_back.svg";
import { renderStatusColor } from "utils/statusColor";
import TableEmptyData from "components/__new/common/TableEmptyData";
import { /* getPayGroups, */ getSinglePayGroup, deletePayGroupEmployee } from 'store/entities/payroll/payrollSetup/action';

const ViewEmployeesGroupDetails = (props) => {
  const history = useHistory()
  const location = useLocation();
  const { id: payGroupId } = useParams();
  const groupDetails = location?.state?.groupDetails
  // eslint-disable-next-line
  const [selected, setSelected] = useState([]);
  const [removeMultipleEmployees, setRemoveMultipleEmployees] = useState(false);
  const {urlQueryParams} = useUrlQueryParams();

  const [listParams, setListParams] = useState({});

  const getEmployees = () => {
    let params = {...listParams};

    params = processParams(urlQueryParams, params, "page", "number", 1, "page");
    params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
    params = processParams(urlQueryParams, params, "search", "string", "", "search");
    params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
    params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");
    params = processParams(urlQueryParams, params, "role", "string", "", "jobTitle");

    if (pageAccess === "enrolled"){
        params = {...params, status: "active"};
    }
    else{
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
    }
    setListParams(params);        
    dispatch(employeesAction.getAllEmployees(params));
}

  const dispatch = useDispatch()
  const { /* getAllGroupsLoading: loading, allGroups: { docs: groups }, */
      groupsDownloadLoading, groupsDownloadData } = useSelector(state => state.entities.groups)
  const { employees, employeesLoading } = useSelector(state => state.entities.employees)
//   console.log(groupDetails)
//     console.log('employees:::', employees)
const {getPayGroupLoading: loading, singlePayGroupData, isSinglePayGroupLoading, deletePayGroupStaffLoading} = useSelector(state => state.entities.payrollSetup)
  const printComponentRef = useRef();
  const groupsDownloadRef = useRef();
  
 /*  const statusBadgeStyle = (status) => {
    if(status === 'active')
        {
            return 'bg-[#ECFDF3] text-[#027A48] '
        } else if(status === 'deactivated')
            {
                return 'bg-[#FEF3F2] text-[#B42318] '
        } else if(status === 'pending')
            {
                return 'bg-[#FEF5E7] text-[##1A202C] '
        } else return '' ;
  } */
 
        const employeesInGroup = useMemo(() => {
            if (!employees?.employees?.docs?.length === 0 || !singlePayGroupData?.data?.length === 0) return [];
           
            return employees?.employees?.docs?.filter((employee) => (singlePayGroupData?.employee_ids || []).includes(employee?._id))
        }, [singlePayGroupData, employees])
  
//   const getGroups = () => {
//       let params = {...listParams};
//       params = processParams(urlQueryParams, params, "search", "string", "", "search");
//       setListParams(params);      
//       // dispatch(groupActions.getAllGroups(params));
//         //   dispatch(groupActions.getGroupsB2b());
//         // dispatch(getPayGroups(params));
//   }
  

  const toggleSingleEmployee = (id) => {
    setRemoveMultipleEmployees(true);
      const alreadyExists = selected?.indexOf(id) > -1
      if (alreadyExists) {
          const filtered = selected?.filter(item => item !== id)
          setSelected(filtered)
      } else {
          setSelected([...selected, id])
      }
  }

  const toggleEntireList = () => {
      if (selected.length !== allEmployeesIDs?.length) {
        setRemoveMultipleEmployees(true);
          setSelected(allEmployeesIDs)
      } else {
        setRemoveMultipleEmployees(false);
          setSelected([])
      }
  }
  
  const handleRemoveEmployee = async (employee) => { 
    const result = await DialogBox({
			title: `Remove ${removeMultipleEmployees ? "Employees" : " Employee"} From Group`,
            content: <div className="text-lg color-[#4A5564]">
                {removeMultipleEmployees ? (
                    <div className="delete-modal-text">
                        Are you sure you want to remove <span className="delete-modal-highlight">{selected?.length} employees</span>? This action cannot be undone.
                    </div>
                ) : "Are you sure you want to perform this action?"}
            </div>,
			buttonYes: "Yes",
            buttonYesClass: "btn-ep-red w-[170px]",
            buttonNoClass: "w-[170px] btn-transparent border border-ep-primary focus:ring-2 focus:ring-transparent ",
			buttonNo: "No",
	});
        
    if(result){
        //   dispatch(groupActions.removeEmployeesFromGroupB2b({name: groupDetails?.name, employees: idArray }, payGroupId)).then(() => getGroups())
        //   if(groupDetails?.employee_ids === 0 ){
        //     history.push('/people/group')
        //   }
        // dispatch(removeEmployeeFromGroup(singlePayGroupData?.id, employee?._id)).then(() => {
        //     getEmployees();
        //     dispatch(getSinglePayGroup({ id: payGroupId }))
        // });
        const employee_ids = employee ? [employee?._id] : selected
        const payload = {
            id: singlePayGroupData?.id,
            employee_ids,
        }
        dispatch(deletePayGroupEmployee(payload)).then(() => {
            setSelected([]);
            getEmployees();
            dispatch(getSinglePayGroup({ id: payGroupId }))
        });
        }
    }
   
   
  const allEmployeesIDs = employeesInGroup?.map(item => item._id)
  
  const pageAccess = props.pageAccess || "all";
  

  const transformedRoles = employeesInGroup?.map(({jobTitle}) => ({
    display: jobTitle,
    payload: jobTitle
}))
// console.log('transformedRolesG::', transformedRoles)

    useEffect(() => {
        // getGroups();
        getEmployees();
        dispatch(getSinglePayGroup({ id: payGroupId }))
        // eslint-disable-next-line
    }, [])
    
    useEffect(() => {
        let params = {...listParams}; 
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        getEmployees(params);
        setRemoveMultipleEmployees(false);
        // eslint-disable-next-line
    }, [location])
    
    useEffect(() => {
        if (selected.length === 0) {   
            setRemoveMultipleEmployees(false);
        }
    }, [selected])
    
    // useEffect(() => {
    //     dispatch(employeesActions.getAllEmployees())
    // }, [])
  
  return (
    <div>
      <DynamicHeadTag headerText={`Company | Groups | ${singlePayGroupData?.data?.name}`} headerDescription="" />
      <div className="flex items-center gap-5">
        <button 
            className="flex items-center justify-center bg-[#ECECEC] w-[48px] h-[48px] rounded-md mr-5"
            onClick={() => history.push('/people/groups')}
        
        >
          <ArrowBack className='' />
        </button>
        <h2 className="page-title">
            {groupDetails?.name}
        </h2>
      </div>
      <div className="mt-6 bg-white px-4 pt-1 relative">
            <div className="font-aeonik text-xl font-medium leading-7 text-left flex items-center">
                Group Employee List
                <span className={`text-[#00535C] text-base ml-4 'bg-ep-light-green' inline-block px-2 py-0.5 rounded-full h-h22 leading-4.5`}>
                    {employeesInGroup?.length || 0}&nbsp;employee{`${employeesInGroup?.length > 1 ? "s" : ""}`}
                    </span>
                </div>
                <div className="mt-6 flex flex-wrap justify-between">
                    <div className="form-group-icon w-max h-10 rounded-md bg-gray-100 border-none">
                            <div className="max-w-sm flex-grow lg:mr-0">
                                <SearchBox placeholder="Search Group List" name="search" extraUrlParams="page=1" />
                            </div>
                    </div>
                    <div className="flex items-center flex-wrap space-x-6">
                        {
                            selected?.length > 0 && (
                                <div>
                                    <button 
                                        className='btn btn-ep-danger-outline'
                                        onClick={() => {
                                                setRemoveMultipleEmployees(true);
                                                handleRemoveEmployee()
                                            }}
                                        >
                                        Remove
                                    </button>
                                </div>
                            )
                        }
                        <Maybe condition={pageAccess === "all"}>
                                <div>
                                    <Filter filters={[
                                        {
                                            title: "Date range",
                                            name: "period",
                                            dataType: "number-range",
                                            options: [
                                                {
                                                    payload: 1,
                                                    display: "Today",
                                                },
                                                {
                                                    payload: 7,
                                                    display: "Last 7 days",
                                                },
                                                {
                                                    payload: 30,
                                                    display: "30 days",
                                                }, 
                                                {
                                                    payload: 365,
                                                    display: "1 year",
                                                },
                                            ],
                                        },
                                        {
                                            title: "Custom date range",
                                            dataType: "date-range",
                                            options: {
                                                from: {
                                                    name: "startDate",
                                                    placeholder: "Start Date",
                                                },
                                                to: {
                                                    name: "endDate",
                                                    placeholder: "End Date",
                                                },
                                            },
                                        },
                                        {
                                            title: "Role",
                                            name: "role",
                                            dataType: "select",
                                            options: transformedRoles,
                                        },
                                        {
                                            title: "Status",
                                            name: "status",
                                            dataType: "select",
                                            options: [
                                                {
                                                    display: "All",
                                                    payload: "",
                                                },
                                                {
                                                    display: "Enrolled",
                                                    payload: "active",
                                                },
                                                {
                                                    display: "Pending",
                                                    payload: "pending",
                                                },
                                                {
                                                    display: "Deactivated",
                                                    payload: "deactivated",
                                                },
                                            ],
                                        },
                                    ]}
                                    />
                                </div>   
                            </Maybe>
                        <div>
                            <DownloadAsCSV
                                ref={groupsDownloadRef}
                                tooltip="Download Group Employees"
                                filename="All employees.csv"
                                columns={[
                                    { label: "Group Name", key: "name" },
                                    { label: "Employee Count", key: "numberOfEmployees" },
                                    { label: "Date Created", key: "createdAt" },
                                ]}
                                click={() => {
                                    dispatch(groupActions.downloadUserGroups({ ...listParams, page: 1, limit: 10000 })).then(() => {
                                        groupsDownloadRef.current?.downloadData()
                                    });
                                }}
                                loading={groupsDownloadLoading}
                                response={groupsDownloadData}
                            />
                        </div>
                        {/* <div>
                            <Print component={printComponentRef} />
                        </div> */}
                    </div>
                </div>
          <div className='mt-8' ref={printComponentRef}>
                    <Table>
                        <Table.Head>
                            <th>
                                <div className="flex items-center mb-6 lg:mb-0">
                                    <input
                                        type="checkbox"
                                        onChange={toggleEntireList}
                                        checked={employeesInGroup?.length > 0 && selected?.length === allEmployeesIDs?.length}
                                        className="w-5 h-5 mr-3.5 form-checkbox float-left"
                                    />
                                </div>
                            </th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email Address</th>
                            <th>Role</th>
                            <th>Date Created</th>
                            <th>Status</th>
                            <th></th>
                        </Table.Head>
                        <Table.Body>
                            
                        <TableContent
                            colspan={8}
                            data={employeesInGroup}
                            loading={loading || isSinglePayGroupLoading || employeesLoading || deletePayGroupStaffLoading}
                            total={employeesInGroup?.length}
                            loadingText={`${deletePayGroupStaffLoading ? `Removing ${removeMultipleEmployees ? "employees": "employee"} from pay group` : "Loading group details"}`}
                            dataContent={employeesInGroup?.length}
                            emptyUI={
                                <TableEmptyData 
                                    actionButtonClicked={() => history.push('/people/groups')}
                                    actionButtonText="Click here to create new group"
                                />
                            }
                        />
                        
                        {(!loading && !employeesLoading && !isSinglePayGroupLoading && !deletePayGroupStaffLoading) && employeesInGroup?.length > 0 && employeesInGroup?.map((employee) =>{
                            // const filteredEmployeeIds = employeesInGroup?.map(emp => emp._id);

                            return <tr key={employee._id}>
                                <td style={{width: "1px"}}>
                                    <input onChange={() => toggleSingleEmployee(employee._id)}
                                        checked={selected?.includes(employee._id)}
                                        type="checkbox" className="w-5 h-5 mr-2 form-checkbox float-lefts" />
                                </td>
                                <td>
                                    <div className='capitalize'>
                                        {employee?.firstName?.toLowerCase()}
                                    </div>
                                </td>
                                <td>
                                    <div className='capitalize'>
                                        {employee?.lastName?.toLowerCase()}
                                    </div>
                                </td>
                                <td>
                                    <div className=''>
                                        {employee?.email}
                                    </div>
                                </td>
                                <td>
                                    <div className='capitalize'>
                                        {employee?.jobTitle}
                                    </div>
                                </td>
                                <td>
                                    {DateFormat(employee.createdAt)}
                                </td>
                                <td>
                                    <div className={`flex items-center text-center py-[2px] capitalize text-[12px] rounded-full leading-[18px] justify-center font-medium ${renderStatusColor(employee?.status)}`}>
                                        {employee.status}
                                    </div>
                                </td>
                                <td>
                                    <button 
                                        className="text-ep-danger-500" 
                                        onClick={() => {
                                            setRemoveMultipleEmployees(false);
                                            handleRemoveEmployee(employee);
                                        }}                                         
                                    >
                                        Remove
                                    </button>
                                </td>
                                
                                        {/* <button onClick={() => history.push(`groups/details/${group._id}`)} className="outline-none text-ep-primary-500 underline">View</button> */}
                                        {/* <button onClick={() => setIsViewGroupOpen((prevState) => !prevState)} className="outline-none text-ep-primary-500 underline">View</button> */}
                                        {/* <button onClick={() => { */}
                                            {/* dispatch(groupActions.selectGroup(group)); */}
                                            {/* history.push(`groups/edit/${group._id}`); */}
                                            {/* }} className="outline-none text-ep-primary-500 underline">Edit</button> */}
                                        {/* <button onClick={() => handleDelete(group)} className="outline-none text-[#EB0000] underline">Delete</button> */}
                                   
                                    
                            </tr>
                            }
                        )}
                        </Table.Body>
                    </Table>
          </div>
        </div>
          
    </div>
  )
}

export default ViewEmployeesGroupDetails